import React, { useState } from 'react'
import queryString from "query-string";

import EmailForm from "../components/EmailForm";
import successIcon from "./icon_success.png"
import { useTranslation } from 'react-i18next';

const DeleteAccount = () => {
    const {t} = useTranslation();
    const [formDone, setFormDone] = useState(false);

    const parsed = queryString.parse(window.location.search);
    // console.log(parsed);
    const token = parsed.token;
    if (formDone) {
        return (
            <div className="content">
                <img src={successIcon} className="Leader-icon" alt={t('success')} />
                <h1>{t('delete_send.success.title')}</h1>
                <br />
                <p>{t('delete_send.success.body')}</p>
                <br />
                <p>{t('contact_support.title')}</p>
                <a href="tel:0800300766">{t('contact_support.body')}</a>
                <br />
                <p>{t('thank.1')}<br />{t('thank.2')}</p>
            </div>
        )
    } else {
        return (
            <div className="content">
                <h1 style={{ color: 'red' }}>{t('delete.title')}</h1>
                <p>{t('delete.body.1')}<br />{t('delete.body.2')}</p>
                <EmailForm token={token} setFormDone={setFormDone} />

                <br /><br />
                <p>{t('contact_support.title')}</p>
                <a href="tel:0800300766">{t('contact_support.body')}</a>
                <br />
                <p>{t('thank.1')}<br />{t('thank.2')}</p>

            </div>
        )
    }
}

export default DeleteAccount;